import subscriptionTrialConfig from './subscriptionTrialConfig.json';

export const DEFAULT_FREE_TRIAL_DAYS = subscriptionTrialConfig.days;
export const FREE_TRIAL_DURATION_DAYS = subscriptionTrialConfig.days;

const TRIAL_ELIGIBLE_INTERVALS = new Set(['month', 'year', '7_day']);
const TRIAL_FIRST_ENTRY_POINTS = new Set(['start_flow', 'register_flow']);

const normalizeString = value =>
  typeof value === 'string' && value.trim().length > 0 ? value.trim().toLowerCase() : '';

const parsePositiveInt = value => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }

  const normalized = Math.trunc(parsed);
  return normalized > 0 ? normalized : null;
};

const isExplicitNoTrial = value => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) && Math.trunc(parsed) <= 0;
};

export const resolveCheckoutTrialConfig = ({
  entryPoint,
  plan,
  trialRequested = false,
  trialEligible = true,
  fallbackTrialDays = DEFAULT_FREE_TRIAL_DAYS,
} = {}) => {
  const normalizedEntryPoint = normalizeString(entryPoint);
  const planInterval = normalizeString(plan?.recurring_interval);
  const rawPlanTrialDays = plan?.trial_days ?? plan?.trialDays ?? null;
  const planTrialDays = parsePositiveInt(rawPlanTrialDays);
  const hasPlanTrialDaysValue =
    rawPlanTrialDays !== null && rawPlanTrialDays !== undefined && rawPlanTrialDays !== '';
  const hasInvalidPlanTrialDays =
    hasPlanTrialDaysValue && !planTrialDays && !isExplicitNoTrial(rawPlanTrialDays);
  const hasExplicitTrialDisable = isExplicitNoTrial(rawPlanTrialDays);
  const fallbackDays = parsePositiveInt(fallbackTrialDays) || DEFAULT_FREE_TRIAL_DAYS;
  const hasIgnoredPlanTrialDays = Boolean(planTrialDays && planTrialDays !== fallbackDays);

  const trialEligibleByFlow =
    TRIAL_FIRST_ENTRY_POINTS.has(normalizedEntryPoint) &&
    TRIAL_ELIGIBLE_INTERVALS.has(planInterval);

  const shouldEnableTrial =
    Boolean(trialEligible) &&
    !hasExplicitTrialDisable &&
    !hasInvalidPlanTrialDays &&
    (Boolean(trialRequested) || trialEligibleByFlow);

  const trialSource = hasInvalidPlanTrialDays
    ? 'invalid_plan_trial_days'
    : hasExplicitTrialDisable
      ? 'plan_trial_disabled'
      : hasIgnoredPlanTrialDays
        ? 'ignored_plan_trial_days'
      : 'default_trial_days';

  return {
    enableTrial: shouldEnableTrial,
    trialDays: shouldEnableTrial ? fallbackDays : null,
    trialFlow: shouldEnableTrial ? 'trial' : 'paid',
    planInterval: planInterval || null,
    trialSource,
  };
};
